import { z } from "zod";


export const TicketMessageSchema = z.object({
    id: z.string().optional(),
    message: z.string().min(1, "Message is required"),
})

export const LevelSchema = z.object({
    id: z.string().optional(),
    level: z.number().min(1, "Level is required"),
    text: z.string().min(1, "Text is required"),
    raw_text: z.string().min(1, "Raw text is required"),
    author: z.string().min(1, "Author is required"),
    country: z.string().optional(),
    era: z.string().min(1, "Era is required"),
})

export const FcmMessageSchema = z.object({
    title: z.string().min(1, "Title is required"),
    body: z.string().min(1, "Body is required"),
    topic: z.string().min(1, "topic is required"),
})

